import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  className?: string;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  className
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-249">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-taupe/60 backdrop-blur-sm animate-[fadeIn_0.2s_ease-out]" onClick={onClose} aria-hidden="true" data-id="element-250" />

      {/* Modal */}
      <div className={cn('relative bg-cream rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col animate-[slideUp_0.3s_ease-out]', className)} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-251">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-beige" data-id="element-252">
          <h2 id="modal-title" className="font-heading text-2xl font-bold text-taupe" data-id="element-253">
            {title}
          </h2>
          <button onClick={onClose} className="w-10 h-10 rounded-full flex items-center justify-center text-taupe-light hover:text-taupe hover:bg-beige transition-colors" aria-label="Cerrar" data-id="element-254">
            <XIcon className="w-5 h-5" data-id="element-255" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto p-6 font-body text-taupe-light leading-relaxed text-sm space-y-4" data-id="element-256">
          {children}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-beige text-center" data-id="element-257">
          <button onClick={onClose} className="px-6 py-2 rounded-full bg-gold hover:bg-gold-dark text-white font-body font-bold text-sm transition-colors" data-id="element-258">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}